import { styled } from '@mui/material'

export const StyledSumRow = styled('div')(({ theme }) => ({
  marginTop: 16,
  backgroundColor: theme.palette.sand.main
}))
